export default __webpack_public_path__ + "static/media/close.6ad492da.svg";